import React from 'react'

const Investors = () => {
  return (
    <div>Investors</div>
  )
}

export default Investors